<template>
  <v-row align="center" justify="center" v-if="childId">
    <v-col md="6">
      <v-card>
        <v-list dense class="pa-0">
          <template v-for="(item, index) in items">
            <v-list-item
              :key="index"
              :to="{ name: item.name }"
              :disabled="!childId"
            >
              <v-list-item-content>
                <v-list-item-title class="text-center">{{
                  item.meta.label
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index + 'divider'"
            />
          </template>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Routes from "@/router/parents";
import { BASE } from "@/config";
import { mapState } from "vuex";

export default {
  name: "MainPage",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      payer: (state) => state.child.payer,
      childId: (state) => state.child.childId,
    }),
    items() {
      return Routes.children.filter((item) => {
        if (item.path !== "" && item.meta && !item.meta.checkTariff) {
          return true;
        }

        if (!item.meta) {
          return false;
        }

        if (this.payer && this.payer.current_tariff) {
          const checkOption = BASE.TARIFF.options.find(
            (o) => o.key === item.meta.checkTariff
          );
          return checkOption && this.payer.current_tariff[checkOption.option];
        }

        return false;
      });
    },
  },
};
</script>
